import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function checkAutoAssign() {
    try {
        const res = await axios.get(`${LEADS_ENDPOINT}/checkAutoAssign`)
        return res.data.data
    } catch {
        throw new Error()
    }
}
